<div class="body_container">
  <!-- <app-component-navigation></app-component-navigation> -->
  <div class="row h-100 w-100 ms-1">
    <div class="w-100 d-flex flex-column h-100 p-0">
      <div class="flex-grow-1 h-100">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
